export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*\W).{8,}$/;
export const deaRegex = /^[A-Za-z]{2}\d{7}$/;
export const npiRegex = /^\d+$/;
